import apiService from '../api/api.service';
import { logger } from '@utils/logger';

class SupportAdminService {
  async getAllTickets(filters = {}) {
    try {
      const response = await apiService.get('/support/admin/tickets', { params: filters });
      return response;
    } catch (error) {
      logger.error('Error fetching all tickets', error);
      throw error;
    }
  }

  async getTicketById(ticketId) {
    try {
      const response = await apiService.get(`/support/admin/tickets/${ticketId}`);
      return response;
    } catch (error) {
      logger.error('Error fetching ticket details', error);
      throw error;
    }
  }

  async updateTicketStatus(ticketId, status, notes = '') {
    try {
      const response = await apiService.put(`/support/admin/tickets/${ticketId}/status`, {
        status,
        notes
      });
      return response;
    } catch (error) {
      logger.error('Error updating ticket status', error);
      throw error;
    }
  }

  async assignTicket(ticketId, adminId) {
    try {
      const response = await apiService.put(`/support/admin/tickets/${ticketId}/assign`, {
        assignedTo: adminId
      });
      return response;
    } catch (error) {
      logger.error('Error assigning ticket', error);
      throw error;
    }
  }

  async addResponse(ticketId, message, isInternalNote = false) {
    try {
      const response = await apiService.post(`/support/tickets/${ticketId}/responses`, {
        message,
        isInternalNote
      });
      return response;
    } catch (error) {
      logger.error('Error adding response', error);
      throw error;
    }
  }

  async getStats() {
    try {
      const response = await apiService.get('/support/admin/stats');
      return response;
    } catch (error) {
      logger.error('Error fetching support stats', error);
      throw error;
    }
  }

  async getAdminList() {
    try {
      const response = await apiService.get('/support/admin/list');
      return response;
    } catch (error) {
      logger.error('Error fetching admin list', error);
      throw error;
    }
  }
}

export default new SupportAdminService();
